/* eslint-disable import/prefer-default-export */
import ApifurClient from '../submodules/apifur-client';
import { apiBase } from './config';

const base = (window && window.windowAPIBase) ? window.windowAPIBase : apiBase;
export const apiClient = (new ApifurClient({ server: base, debug: true, useAgent: false }));
